import { AI_PHOTO_MAKER_ICON, DRIVE_MP3_ICON, DRIVE_MP4_ICON, SMART_IMAGE_ICON, BILIBILI_ICON, CANVA_ICON, CLOUDCAD_ICON, DRIVE_DOC_ICON, DRIVE_EXCEL_ICON, DRIVE_PDF_ICON, DRIVE_PPT_ICON, DRIVE_TXT_ICON, DRIVE_XMIND_ICON, EVERNOTE_ICON, MODAO_ICON, MOKE_ICON, PROCESSON_ICON, TENCENT_VIDEO_ICON, VIDEO_EDITOR_ICON } from '@src/framework/frame/components/animation-editor/images';
import { ELEMENT_ICON, ELEMENT_TYPE_TEXT } from '@src/framework/frame/components/animation-editor/animationItem/constants';
import { TOOLBAR_SHAPE, TOOLBAR_TEXT } from '@src/framework/editor/src/img/pageIndex';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { LineType } from '@src/slide/infrastructure/module/dependent/line-info';
import { getShapeNameByPrstGeom, getShapeTextRun } from '@src/js/utils';
import i18n from '@i18next/i18n';
import { STShapeType } from '@tencent/slide-sdk-model';

export const CONNECTOR_TITLE = {
    [LineType.LINE]: i18n.t('线条'),
    [LineType.NONE]: i18n.t('自由曲线'),
    [LineType.CUSTOM]: i18n.t('自由曲线'),
    [LineType.STRAIGNTCONNECTOR1]: i18n.t('直线'),
    [LineType.BENTCONNECTOR1]: i18n.t('连接符'),
    [LineType.BENTCONNECTOR2]: i18n.t('连接符'),
    [LineType.BENTCONNECTOR3]: i18n.t('连接符'),
    [LineType.BENTCONNECTOR4]: i18n.t('连接符'),
    [LineType.BENTCONNECTOR5]: i18n.t('连接符'),
    [LineType.CURVEDCONNECTOR2]: i18n.t('连接符'),
    [LineType.CURVEDCONNECTOR3]: i18n.t('连接符'),
    [LineType.CURVEDCONNECTOR4]: i18n.t('连接符'),
    [LineType.CURVEDCONNECTOR5]: i18n.t('连接符'),
};

// 动画列表icon
export const ANIM_HEADER_INFO = {
    tencentvideo: { name: i18n.t('腾讯视频'), icon: TENCENT_VIDEO_ICON },
    bilibili: { name: i18n.t('哔哩哔哩'), icon: BILIBILI_ICON },
    evernote: { name: i18n.t('印象笔记'), icon: EVERNOTE_ICON },
    processon: { name: i18n.t('ProcessOn'), icon: PROCESSON_ICON },
    canva: { name: i18n.t('Canva'), icon: CANVA_ICON },
    modao: { name: i18n.t('墨刀'), icon: MODAO_ICON },
    moke: { name: i18n.t('摹客'), icon: MOKE_ICON },
    cloudcad: { name: i18n.t('云图三维'), icon: CLOUDCAD_ICON },
    videoEditor: { name: i18n.t('视频剪辑'), icon: VIDEO_EDITOR_ICON },
    pptx: { name: i18n.t('本地文档'), icon: DRIVE_PPT_ICON },
    docx: { name: i18n.t('本地文档'), icon: DRIVE_DOC_ICON },
    xlsx: { name: i18n.t('本地文档'), icon: DRIVE_EXCEL_ICON },
    pdf: { name: i18n.t('本地文档'), icon: DRIVE_PDF_ICON },
    xmind: { name: i18n.t('本地文档'), icon: DRIVE_XMIND_ICON },
    txt: { name: i18n.t('本地文档'), icon: DRIVE_TXT_ICON },
};
const CUSTOM = 'custom';
const SMART_IMAGE_ID = '1bb3d650a97c41a9b25b46679e0631f9';
const AI_PHOTO_MAKER_ID = '6682b5e614a64690a2080d893d84a088';

type IDisplayInfo = {name: string, icon: string};

/**
 * 获取元素展示的具体名称
 * @param {*} elementModel 元素
 * @param {*} showTextRun 是否展示文本内容
 * @param {*} showId 是否展示id
 * @returns
 */
export const getElementDetailDisplayInfo = ({
    elementModel, showTextRun = true, showId = false, useSdkName = true }:
{elementModel: any, showTextRun?: boolean, showId?: boolean, useSdkName?: boolean}): IDisplayInfo => {
    const typeToNameMap = {
        [UIModelType.SHAPE]: () => getTextInfo(elementModel, useSdkName),
        [UIModelType.CONNECTOR]: () => getConnectorInfo(elementModel),
        [UIModelType.CHART]: () => ({ name: i18n.t('图表'), icon: ELEMENT_ICON[elementModel.type] }),
        [UIModelType.IMAGE]: () => getImageInfo(elementModel),
        [UIModelType.TABLE]: () => getDisplayNameAndIcon({ type: i18n.t('表格'), elementModel, showTextRun, showId, useSdkName }),
        [UIModelType.GROUP]: () => getDisplayNameAndIcon({ type: i18n.t('组合'), elementModel, showTextRun, showId, useSdkName }),
        [UIModelType.SMART_ART]: () => ({ name: i18n.t('smartArt'), icon: ELEMENT_ICON[elementModel.type] }),
    };
    return typeToNameMap[elementModel.type] ? typeToNameMap[elementModel.type]() : { name: i18n.t('自定义图形'), icon: '' };
};

const getDisplayNameAndIcon = ({ type, elementModel, showTextRun = true, showId = false, useSdkName = true }:
{type: string, elementModel: any, showTextRun?: boolean, showId?: boolean, useSdkName?: boolean}): IDisplayInfo => {
    let shapeName: string;
    // 动画面板设置项不使用sdk名称，仅选择窗格和触发器下拉框使用
    if (useSdkName && elementModel.sdkData.name) {
        shapeName = elementModel.sdkData.name;
    } else {
        // 本地导入的shape有name，在线创建的无name
        // 为了避免本地导入shape展示问题，如：椭圆 12 12
        // 只允许在线创建的shape开启showId
        shapeName = type;
        if (showId) {
            shapeName += ` ${elementModel.id}`;
        }
    }
    if (shapeName?.indexOf('：') !== -1) {
        const shapeNameArr = shapeName.split('：');
        shapeName = `${shapeNameArr[0]}(${shapeNameArr[1]})`;
    }
    if (showTextRun && getShapeTextRun(elementModel)) {
        shapeName += `: ${getShapeTextRun(elementModel)}`;
    }
    return { name: shapeName, icon: ELEMENT_ICON[elementModel.type] };
};

const getTextInfo = (elementModel, useSdkName = true): IDisplayInfo => {
    const addonInfo = getTextAddonInfo(elementModel);
    if (addonInfo) return addonInfo;
    const attachmentInfo = getAttachmentInfo(elementModel);
    if (attachmentInfo) return attachmentInfo;
    const icon = elementModel.isTextOrPlaceholder ? TOOLBAR_TEXT : TOOLBAR_SHAPE;
    const { name } = getShapeTitle(elementModel, useSdkName);
    return { name, icon };
};

const getConnectorInfo = (elementModel): IDisplayInfo => ({
    name: getConnectorTitle(elementModel),
    icon: ELEMENT_ICON[elementModel.type],
});
const getConnectorTitle = (elementModel): string => {
    const { bgLine } = elementModel.props.style;
    return CONNECTOR_TITLE[bgLine] ?? i18n.t('图形');
};

const getImageInfo = (elementModel): IDisplayInfo => {
    let name = ELEMENT_TYPE_TEXT[elementModel.type];
    let icon = ELEMENT_ICON[elementModel.type];
    if (elementModel.video) {
        // 附件二期之前上传的视频 name 在 video 字段中，兼容下之前的逻辑
        name = elementModel.name ?? elementModel.video.name ?? i18n.t('视频');
        icon = DRIVE_MP4_ICON;
        return { name, icon };
    }
    if (elementModel.audio) {
        // 附件二期之前上传的音频 name 在 audio 字段中，兼容下之前的逻辑
        name = elementModel.name ?? elementModel.audio.name ?? i18n.t('音频');
        icon = DRIVE_MP3_ICON;
        return { name, icon };
    }
    const addonDocElement = elementModel.props.addon?.docElement;
    if (addonDocElement?.src) {
        if (addonDocElement.sourceType === 'latex') {
            name = i18n.t('公式');
            return { name, icon };
        }
        const urlList = [
            { origin: SMART_IMAGE_ID, info: { name: i18n.t('智能抠图'), icon: SMART_IMAGE_ICON } },
            { origin: AI_PHOTO_MAKER_ID, info: { name: i18n.t('制作证件照'), icon: AI_PHOTO_MAKER_ICON } },
        ];
        const addonInfo = getAddonInfo(urlList, addonDocElement.addonId, { name, icon });
        if (addonInfo) return addonInfo;
    }
    return { name, icon };
};

const getTextAddonInfo = (elementModel): IDisplayInfo | null => {
    const { addon } = elementModel.props;
    if (!addon || addon?.displayMode === 'normal') return null;
    const { originUrl } = addon;
    const urlList = [
        { origin: 'https://v.qq.com', info: ANIM_HEADER_INFO.tencentvideo },
        { origin: 'https://www.bilibili.com', info: ANIM_HEADER_INFO.bilibili },
        { origin: 'https://app.yinxiang.com', info: ANIM_HEADER_INFO.evernote },
        { origin: 'https://www.processon.com', info: ANIM_HEADER_INFO.processon },
        { origin: 'https://www.canva.cn', info: ANIM_HEADER_INFO.canva },
        { origin: 'https://modao.cc', info: ANIM_HEADER_INFO.modao },
        { origin: 'https://app.mockplus.cn', info: ANIM_HEADER_INFO.moke },
        { origin: 'https://www.yuntucad.com', info: ANIM_HEADER_INFO.cloudcad },
        { origin: 'https://zenvideo.qq.com', info: ANIM_HEADER_INFO.videoEditor },
    ];
    return getAddonInfo(urlList, originUrl);
};

const getAttachmentInfo = (elementModel): IDisplayInfo | null => {
    const { attachment } = elementModel.props;
    if (!attachment) return null;
    const attachmentList = [
        { type: 'pptx', icon: ANIM_HEADER_INFO.pptx.icon },
        { type: 'docx', icon: ANIM_HEADER_INFO.docx.icon },
        { type: 'xlsx', icon: ANIM_HEADER_INFO.xlsx.icon },
        { type: 'pdf', icon: ANIM_HEADER_INFO.pdf.icon },
        { type: 'xmind', icon: ANIM_HEADER_INFO.xmind.icon },
        { type: 'txt', icon: ANIM_HEADER_INFO.txt.icon },
    ];
    for (let index = 0; index < attachmentList.length; index++) {
        const { type, icon } = attachmentList[index];
        if (attachment.type === type) {
            return { name: attachment.name, icon };
        }
    }
    return null;
};

const getShapeTitle = (elementModel, useSdkName = true): IDisplayInfo => {
    if (elementModel.isText) {
        return getDisplayNameAndIcon({ type: i18n.t('文本框'), elementModel, showTextRun: true, useSdkName });
    }
    if (elementModel.isPlaceholder) {
        return getDisplayNameAndIcon({ type: i18n.t('占位符'), elementModel, showTextRun: true, useSdkName });
    }
    const prstGeom = elementModel.sdkData?.props?.spPr?.prstGeom?.prst;
    if (prstGeom) {
        return getDisplayNameAndIcon({ type: getShapeNameByPrstGeom(prstGeom), elementModel,
            showTextRun: true, useSdkName });
    }
    const { bgShape } = elementModel.props.style;
    return getDisplayNameAndIcon({ type: bgShape === CUSTOM ? i18n.t('自定义图形') : i18n.t('图形'), elementModel, showTextRun: true, useSdkName });
};

const getAddonInfo = (list, url: string, defaultInfo?): IDisplayInfo | null => {
    for (let index = 0; index < list.length; index++) {
        const { origin, info } = list[index];
        if (url.startsWith(origin)) {
            return info;
        }
    }
    return defaultInfo ?? null;
};
